import React from "react";
import ReactDOMServer from "react-dom/server";
import VacancyContractAdditionalTenantAddress from "./VacancyContractAdditionalTenantAddress";

export const getVacancyContractAddressHtml = (applicantCount?: number) => {
  return ReactDOMServer.renderToString(
    <VacancyContractAddress applicantCount={applicantCount} />
  );
};

type Props = {
  applicantCount?: number;
};

const VacancyContractAddress = (props: Props) => {
  const { applicantCount = 1 } = props;

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>
        <strong>Wohnraummietvertrag</strong>
      </h2>
      <br />
      <br />
      <p style={{ display: "flex", alignItems: "center" }}>
        <span className="mention-variable" data-variable-id="entityDisplayName">
          $EntityDisplayName
        </span>
        <span style={{ marginLeft: "auto" }}>-Vermieter-</span>
      </p>
      <p>
        <span className="mention-variable" data-variable-id="entityStreet">
          $EntityStreet
        </span>
      </p>
      <p>
        <span className="mention-variable" data-variable-id="entityZip">
          $EntityZip
        </span>{" "}
        <span className="mention-variable" data-variable-id="entityCity">
          $EntityCity
        </span>
      </p>
      <br />
      <br />
      <p>vertreten durch</p>
      <br />
      <br />
      <p style={{ display: "flex", alignItems: "center" }}>
        TPM GmbH
        <span style={{ marginLeft: "auto" }}>-Verwalter-</span>
      </p>
      <p>Bahnhofstraße 1-3</p>
      <p>33102 Paderborn</p>
      <br />
      <br />
      <p>schließt mit</p>

      {Array.from({ length: applicantCount }, (_, index) => (
        <div key={index}>
          <VacancyContractAdditionalTenantAddress tenantIndex={index} />
        </div>
      ))}

      <br />
      <br />
      <p>diesen Dauermietvertrag.</p>
      <br />
      <br />
      <div style={{ pageBreakInside: "avoid" }}>
        <p>
          <strong>Konto für Mietzahlung:</strong>
        </p>
        <br />
        <p style={{ textAlign: "justify" }}>
          <span>
            <strong>
              Gesellschaft:{" "}
              <span
                className="mention-variable"
                data-variable-id="entityDisplayName"
              >
                $EntityDisplayName
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              IBAN:&nbsp;
              <span className="mention-variable" data-variable-id="iban">
                $IBAN
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              BIC:&nbsp;
              <span className="mention-variable" data-variable-id="bic">
                $BIC
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              Kreditinstitut:&nbsp;
              <span className="mention-variable" data-variable-id="bankName">
                $Bankname
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              Verwendungszweck:&nbsp;
              <span
                className="mention-variable"
                data-variable-id="bankUsageReference"
              >
                $Bank-Usage-Reference
              </span>
            </strong>
          </span>
        </p>
      </div>
      <p>
        Die Angabe der Objektnummer und Mieternummer ist zwingend erforderlich,
        da eine Zuordnung der Zahlung zum Mietkonto andernfalls nicht erfolgen
        kann.
      </p>
    </div>
  );
};

export default VacancyContractAddress;
